<template>
  <v-container fluid grid-list-xl fill-height>
    <v-layout row wrap fill-height justify-center align-center>
      <v-flex d-flex xs12 sm10 md8 lg5>
        <v-card elevation="8">
          <v-container grid-list-xl>
            <v-layout row wrap text-xs-center>
              <v-flex xs12 class="display-2 font-weight- primary--text">Contact Us</v-flex>
            </v-layout>
          </v-container>

          <v-container grid-list-xl>
            <v-form>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field outline label="Your Name" v-model="name" required></v-text-field>
                <!-- </v-flex>
                <v-flex xs12> -->
                  <v-text-field outline label="Your Email" v-model="email" required></v-text-field>
                <!-- </v-flex>
                <v-flex xs12> -->
                  <v-textarea outline label="Your Message" v-model="message" required></v-textarea>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>

          <v-container grid-list-xl class="primary">
            <v-layout row wrap>
              <v-flex xs12>
                <v-layout row wrap>
                  <img height="54px" :src="require('@/assets/logo-light.svg')">
                  <v-spacer></v-spacer>
                  <v-btn @click="submitForm()" elevation="8" hover large color="white primary--text" to="/contact">
                    Submit
                    <v-icon right color="primary" >mdi-send</v-icon>
                  </v-btn>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
    <v-snackbar v-model="snackbar" top color="primary">
      {{ snackbarText }}
    </v-snackbar>
  </v-container>
</template>

<script>
const fb = require('../services/firebase.js')
export default {
  data() {
    return {
      name: "",
      email: "",
      message: "",
      snackbar: false,
      snackbarText: 'Message Sent!',
    };
  },
  methods: {
    submitForm() {
      console.log("I'm pushed")
      fb.messagesCollection.add({
        name: this.name,
        email: this.email,
        message: this.message
      }).then(() => {
        this.name = ""
        this.email = ""
        this.message = ""
        this.snackbar = true
      })
    }
  }
};
</script>

<style>
.v-btn.v-btn--active:before,
.v-btn:focus:before {
  opacity: 0;
}
</style>
